import { Section } from '../Section';
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Documents.css';
import { ArticleParagraph1 } from '@cian/ui-kit';
import { IDocument } from '../../types/builder';

interface IDocumentsProps {
  items: IDocument[];
  expandButton: JSX.Element | null;
  inColumn?: boolean;
  onDocumentClick(url: string): void;
}

export const Documents: React.FC<IDocumentsProps> = ({ items, expandButton, inColumn, onDocumentClick }) => {
  return (
    <Section title="Документы и сертификаты" dataName="Documents">
      <div className={styles['documents']}>
        {items.map(({ name, url }, index) => (
          <div className={clsx(styles['link-container'], inColumn && styles['fullwidth'])} key={index}>
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className={styles['link']}
              onClick={() => onDocumentClick(url)}
            >
              <ArticleParagraph1 color="primary_100" as="div">
                {name}
              </ArticleParagraph1>
            </a>
          </div>
        ))}
      </div>
      {expandButton}
    </Section>
  );
};
